import { useState, useEffect } from 'react';
import { detectLang, setLang, t } from '../utils/langState';
import { initializeFavicons, updateMetaTags } from '../utils/branding';

export const useLanguage = () => {
  const [currentLang, setCurrentLang] = useState(detectLang);

  useEffect(() => {
    // Initialize favicons and static meta tags on first load
    initializeFavicons();
    
    // Update meta tags for current language
    const translate = (key) => t(currentLang, key);
    updateMetaTags(currentLang, translate);
  }, []);

  useEffect(() => {
    // Listen for language changes
    const handleLanguageChange = (event) => {
      setCurrentLang(event.detail);
    };

    window.addEventListener('languageChanged', handleLanguageChange);

    // Also check URL on mount in case it changed
    const urlLang = detectLang();
    if (urlLang !== currentLang) {
      setCurrentLang(urlLang);
    }

    return () => {
      window.removeEventListener('languageChanged', handleLanguageChange);
    };
  }, [currentLang]);

  // Update meta tags when language changes
  useEffect(() => {
    const translate = (key) => t(currentLang, key);
    updateMetaTags(currentLang, translate);
  }, [currentLang]);

  const switchLang = (newLang) => {
    setLang(newLang);
    setCurrentLang(newLang);
  };

  const translate = (key) => t(currentLang, key);

  return {
    currentLang,
    switchLang,
    t: translate
  };
};